import { Modal, Typography } from "antd";
const { Paragraph, Text } = Typography;

const TemplateEmailPreview = ({ visible, onClose }) => {
  return (
    <Modal
      getContainer={false}
      title="Exemplo de Template de E‑mail"
      open={visible}
      onCancel={onClose}
      width={850}
      footer={null}
      centered
    >
      <Paragraph>
        Este é um exemplo básico do template de e‑mail que será enviado nas solicitações.
      </Paragraph>
      
      <Paragraph>
        Sempre que houver uma tag <strong>#Tag#</strong>, ela será substituída
        pelo conteúdo variável de uma solicitação, de acordo com as tags mapeadas
        e disponíveis no sistema. No caso deste exemplo, as tags existentes são:  
        <strong> #Titulo#</strong>, <strong>#ConteudoPrincipal#</strong> e 
        <strong> #LinkSolicitacao#</strong>
      </Paragraph>

      <img
        src="/ExemploTemplate.webp"
        alt="Exemplo de Template de E-mail com tags destacadas"
        width="800"
        style={{ display: "block", margin: "0 auto" }}
      />
    </Modal>
  );
};

export default TemplateEmailPreview;
